import React, { useState, useContext, useEffect } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { useHistory, useLocation } from "react-router-dom";
import ContextComponent from "../Context";
import "../Containers/helpContainer.css";

const HelpSearchBox = ({ helps, setSearchedHelps }) => {
  const context = useContext(ContextComponent);
  const history = useHistory();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState(
    context.query_parameters["search_term"] || "",
  );
  const findSearched = term => {
    const results = helps.filter(
      help => help.title.includes(term) || help.body.includes(term),
    );
    setSearchedHelps(results);
    sessionStorage.setItem("searchedHelp", JSON.stringify(results));
  };

  const handleSearch = term => {
    history.push(`/help?search_term=${term}`);
    findSearched(term);
  };

  useEffect(() => {
    const saved = sessionStorage.getItem("searchedHelp");
    if (saved) {
      setSearchedHelps(JSON.parse(saved));
    }
  }, [setSearchedHelps]);

  useEffect(() => {
    if (location.search === "") {
      setSearchTerm("");
    }
  }, [location]);
  
  return (
    <div className="search-container">
      <InputGroup className="mb-3 SearchBox">
        <InputGroup.Prepend>
          <div className="search-btn" onClick={() => handleSearch(searchTerm)}>
            <FaSearch className="search-btn-icon" />
          </div>
        </InputGroup.Prepend>
        <FormControl
          className="search-form"
          placeholder="جستجو..."
          value={searchTerm}
          onChange={e => {
            const term = e.target.value;
            setSearchTerm(term);
            context.query_parameters["search_term"] = term;
          }}
        />
      </InputGroup>
    </div>
  );
};

export default HelpSearchBox;
